import {Card, Layout, Spin} from 'antd';
import {inject, observer} from 'mobx-react';
import React, {useEffect} from 'react';
import Header from './Header';
import TransferForm from './TransferForm';
import TrxItem from './TrxItem';

const {Content, Footer} = Layout;

const Dashboard = (props) => {
  const {loading, user, transactions} = props.store;

  const lastTrx = transactions.items[0];
  const lastPending = !transactions.loading && lastTrx && lastTrx.status === 'pending';

  useEffect(() => {
    if (lastPending) {
      transactions.startPolling(1000);
      return () => transactions.stopPolling();
    }
  }, [lastPending]);

  if (loading) return null;
  return (
    <Layout style={{minHeight: '100%'}}>
      <Header />
      <Layout className="main-layout">
        <Content>
          <Card className="main-card">
            <div className="current-balance">
              <div className="current-balance__label">Current balance</div>
              <div className="current-balance__value">{user.balanceFormatted} EURM</div>
            </div>
            <div className="transfer-form">
              <TransferForm />
            </div>
            {transactions.loading && (
              <div className="loader">
                <Spin />
              </div>
            )}
            <div className="trx-list">
              {transactions.items.map((item) => (
                <TrxItem key={item.id} item={item} />
              ))}
            </div>
          </Card>
        </Content>
      </Layout>
      <Footer style={{textAlign: 'center'}}>
        ©{new Date().getFullYear()}{' '}
        <a href="https://monei.net" target="_blank">
          monei.com
        </a>
      </Footer>
    </Layout>
  );
};

export default inject('store')(observer(Dashboard));
